// extracted by mini-css-extract-plugin
export default {"socialLinks":"socialLinks-module--socialLinks--a73b1","link":"socialLinks-module--link--018cf","icon":"socialLinks-module--icon--98ce6","fadeIn":"socialLinks-module--fadeIn--3b6c0"};